(function () {
  'use strict';
  if (window.__wbLpViewItem || window.Shopify?.designMode) return;
  const configNode = document.getElementById('WbLpViewItemConfig');
  if (!configNode || !window.IntersectionObserver) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  const allowed = () => config.pageType === 'page'
    && config.pathname === location.pathname
    && !window.Shopify?.designMode;
  if (!allowed() || typeof config.itemIdFormat !== 'string'
      || !config.itemIdFormat.includes('{variant_id}')) return;

  const sent = new Set();
  const controllers = new Map();
  window.__wbLpViewItem = { sent };
  const safe = (fn) => { try { fn(); } catch (_) {} };
  const text = (value) => typeof value === 'string' ? value.trim() : '';
  const priceCents = (value) => {
    const raw = text(value);
    const cents = /^\d+$/.test(raw) ? Number(raw) : NaN;
    return Number.isSafeInteger(cents) ? cents : NaN;
  };

  function displayedTotal(wrapper, source, variantId, planId) {
    const percent = Number.parseFloat(wrapper.dataset.promoDiscountPercent || '0');
    const promo = ['true', '1', 'yes'].includes(
      String(wrapper.dataset.promoEnabled || '').toLowerCase()
    ) && Number.isFinite(percent) && percent > 0 && percent < 100;
    if (planId) {
      const pricing = [...(source.closest('.subscription-plan-item')
        ?.querySelectorAll('.plan-pricing') || [])].find((node) =>
        node.dataset.variantId === variantId && node.dataset.sellingPlanId === planId);
      const current = pricing?.querySelector('.price-current[data-subscription-price]');
      // Read the existing full-package display total, never rounded monthly text.
      if (promo && current?.dataset.wbPromoApplied !== 'true') return NaN;
      const displayed = priceCents(current?.dataset.subscriptionPrice);
      return Number.isSafeInteger(displayed) || promo
        ? displayed : priceCents(source.dataset.ga4PriceCents);
    }
    if (promo) {
      // One-time display attributes contain monthly prices only. Use the same
      // original package cents and percentage as the existing display formatter.
      const original = priceCents(source.dataset.variantPriceCents);
      return Number.isSafeInteger(original) && original > 0
        ? Math.max(0, Math.round(original * (100 - Math.min(99, percent)) / 100)) : NaN;
    }
    return priceCents(source.dataset.ga4PriceCents);
  }

  function context(root) {
    const wrappers = [...root.querySelectorAll('.wonderbiotics-subscriptions-wrapper')];
    if (wrappers.length !== 1) return null;
    const wrapper = wrappers[0];
    const instance = wrapper.wonderbioticsSubscriptions;
    if (!instance || !instance.selectedVariant) return null;
    const productId = text(wrapper.dataset.ga4ProductId);
    const variantId = String(instance.selectedVariant);
    const planId = instance.selectedSellingPlan ? String(instance.selectedSellingPlan) : '';
    const itemName = text(wrapper.dataset.ga4ProductTitle);
    const currency = text(wrapper.dataset.ga4Currency);
    if (!productId || !itemName || !/^\d+$/.test(variantId)) return null;
    let source;
    let variantName;
    if (planId) {
      source = [...wrapper.querySelectorAll('.plan-radio:not(.one-time-radio)')]
        .find((radio) => radio.dataset.variantId === variantId
          && (radio.dataset.sellingPlanId || radio.value) === planId);
      variantName = source?.dataset.ga4VariantName
        || source?.closest('.variant-subscription-card')?.dataset.ga4VariantName;
    } else {
      source = [...wrapper.querySelectorAll('.one-time-variant-selector option')]
        .find((option) => (option.dataset.variantId || option.value) === variantId);
      variantName = source?.dataset.ga4VariantName || source?.dataset.variantOriginalTitle;
    }
    if (!source) return null;
    const itemId = config.itemIdFormat
      .replaceAll('{product_id}', productId).replaceAll('{variant_id}', variantId);
    if (!itemId || /[{}]/.test(itemId)) return null;
    const item = { item_id: itemId, item_name: itemName,
      item_product_id: productId, quantity: 1 };
    if (text(variantName)) item.item_variant = text(variantName);
    const ecommerce = { items: [item] };
    const cents = displayedTotal(wrapper, source, variantId, planId);
    if (Number.isSafeInteger(cents) && /^[A-Z]{3}$/.test(currency)) {
      const price = cents / 100;
      item.price = price;
      ecommerce.currency = currency;
      ecommerce.value = price;
    }
    return { key: productId, ecommerce, selectionKey: variantId + ':' + planId };
  }

  function mount(root) {
    if (!allowed() || controllers.has(root)) return;
    const anchor = root.querySelector('.product__info-wrapper .product__title');
    if (!anchor) return;
    let visible = false;
    const geometryVisible = () => {
      const rect = anchor.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) return false;
      for (let node = anchor; node; node = node.parentElement) {
        const style = getComputedStyle(node);
        if (style.display === 'none' || style.visibility === 'hidden'
            || Number(style.opacity) === 0) return false;
        if (node === root) break;
      }
      const width = Math.max(0, Math.min(rect.right, innerWidth) - Math.max(rect.left, 0));
      const height = Math.max(0, Math.min(rect.bottom, innerHeight) - Math.max(rect.top, 0));
      return width * height / (rect.width * rect.height) >= 0.001;
    };
    function attempt() {
      if (!allowed() || !root.isConnected || !visible
          || document.visibilityState !== 'visible' || !geometryVisible()) return;
      const snapshot = context(root);
      if (!snapshot) return;
      if (sent.has(snapshot.key)) { destroy(); return; }
      window.dataLayer = window.dataLayer || [];
      if (typeof window.dataLayer.push !== 'function') return;
      sent.add(snapshot.key);
      document.dispatchEvent(new CustomEvent('wb:lp-measurement-needed'));
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: 'wb_product_detail_view', page_type: 'page',
        detail_surface: 'marketing_landing', tracking_source: 'theme_lp_detail',
        ecommerce: snapshot.ecommerce });
      destroy();
    }
    const onChange = () => queueMicrotask(() => safe(attempt));
    const observer = new IntersectionObserver((entries) => safe(() => {
      const entry = entries[entries.length - 1];
      visible = entry.isIntersecting && entry.intersectionRatio >= 0.001;
      attempt();
    }), { threshold: [0, 0.001], rootMargin: '0px' });
    function destroy() {
      observer.disconnect();
      root.removeEventListener('wonderbioticsSubscriptions:subscriptionSelected', onChange);
      root.removeEventListener('transitionend', onChange);
      root.removeEventListener('animationend', onChange);
      document.removeEventListener('visibilitychange', onChange);
      controllers.delete(root);
    }
    controllers.set(root, { restart: onChange, destroy });
    root.addEventListener('wonderbioticsSubscriptions:subscriptionSelected', onChange);
    root.addEventListener('transitionend', onChange);
    root.addEventListener('animationend', onChange);
    document.addEventListener('visibilitychange', onChange);
    observer.observe(anchor);
  }

  function scan() {
    if (!allowed()) { controllers.forEach((entry) => entry.destroy()); return; }
    controllers.forEach((entry, root) => { if (!root.isConnected) entry.destroy(); });
    document.querySelectorAll('[data-wb-featured-product-section]').forEach((root) => safe(() => mount(root)));
    controllers.forEach((entry) => entry.restart());
  }
  // The existing promotion formatter handles the same event after this listener.
  document.addEventListener('wb:subscriptions-ready', () => queueMicrotask(() => safe(scan)));
  document.addEventListener('shopify:section:load', () => safe(scan));
  document.addEventListener('shopify:section:unload', (event) => safe(() => {
    controllers.forEach((entry, root) => {
      if (event.target === root || event.target.contains(root)) entry.destroy();
    });
  }));
  window.addEventListener('pagehide', () => controllers.forEach((entry) => entry.destroy()));
  window.addEventListener('pageshow', () => safe(scan));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => safe(scan), { once: true });
  } else { safe(scan); }
})();
